<template>
  <div @click="checkout">
    <q-btn
      v-bind="$attrs"
      data-test-id="draft-order-cart-header-icon"
      flat
      :dense="$q.screen.lt.sm"
      round
      icon="fal fa-cart-shopping"
      size="12px"
      :to="routerLink"
    >
      <q-badge
        :label="$order.draftOrderItemsCartCount"
        color="red"
        floating
      />
    </q-btn>
  </div>
</template>

<script>
export default {
  name: 'CartButton',
  computed: {
    routerLink () {
      const isDigitalOnly = (this.$order?.purchasingGiftCards || this.$order?.purchasingVouchers || this.$order?.purchasingDonation || this.$checkoutData.purchasingMembership) &&
      !(this.$order?.purchasingTickets || this.$order?.purchasingItems)
      if ((isDigitalOnly || !this.$checkoutData.hasRedemptions) && this.$q.screen.lt.sm) {
        return { name: 'checkout:payment' }
      } else {
        return { name: 'checkout:cart' }
      }
    }
  },
  methods: {
    checkout () {
      this.$trackEvent(this.$customerEvents.CLICKED_CART_HEADER_ICON)
    }
  }
}
</script>
